import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatTableDataSource, PageEvent, MatPaginator } from '@angular/material';
import { Subject, Subscription } from 'rxjs';
import { ComponentPageTitle } from 'src/app/page-title/page-title.component';
import { BusquedaService } from '../busqueda.service';
import { GatewayService } from 'src/app/gateway.service';
import { FiltroPaisService } from '../filtro-pais.service';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormGroup, FormControl } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-fallas-pendientes',
  templateUrl: './fallas-pendientes.component.html',
  styleUrls: ['./fallas-pendientes.component.scss']
})
export class FallasPendientesComponent implements OnInit {
  private destroy$ = new Subject<void>();

  statusCodes = [
    { value: '', label: 'Todos' },
    { value: 'O', label: 'O - Open' },
    { value: 'S', label: 'S - Suspended' },
    { value: 'U', label: 'U - Uncleared' }
  ];

  grupoVal = new FormGroup({
    BUSCAR: new FormControl(''),
    FAULT_STATUS_CODE: new FormControl(''),
    FECHAINI: new FormControl(''),
    FECHAFIN: new FormControl('')
  });

  tableColumns: string[] = [
    'FAULT_ID', 'ACCT_NO', 'CONTACT_NAME', 'CST_REFERENCE',
    'DEPARTMENT', 'FAU_CUST_TYPE', 'NODO', 'FAULT_STATUS_CODE', 'DATE_RAISED', 'AGENDAMIENTO'
  ];

  dataSource = new MatTableDataSource<any>([]);
  private subscription: Subscription;
  private subscriptionpais: Subscription;
  FILTER; resultsLength = 0;
  pageSize = 10;
  idpais;
  pageEvent: PageEvent;
  public actpage: number = 0;
  @ViewChild('paginatortable') paginatortable: MatPaginator;

  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    private gateway: GatewayService,
    public pageTitle: ComponentPageTitle,
    public _busqueda: BusquedaService,
    public _filtroPais: FiltroPaisService,
    private localSave: LocalSaveService
  ) { }

  ngOnInit() {
    const user = this.localSave.get('usuarioPGV');
    if (!user || (user.idrol != 1 && user.idrol != 27)) {
      this.router.navigate(['/home']);
    }
    this.idpais = this.localSave.get('pais');
    this.get(0);
    this.pageTitle.title = 'Fallas Pendientes';

    this.subscription = this._busqueda.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
      res => {
        this.filtrarAgente(res.filtro);
      });

    this.subscriptionpais = this._filtroPais.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
      res => {
        this.idpais = res.IDPAIS;
        this.get(0);
      }
    );
  }

  filter = '';
  public keyDownFunction(event) {
    if (event.keyCode == 13) {
      this.filtrogeneral();
    } else if (event.keyCode == 8 && this.filter == '') {
      this.filtrogeneral();
    }
  }

  public filtrogeneral() {
    if (this.paginatortable) {
      this.paginatortable.firstPage();
    }
    this._busqueda.notificarBusqueda({ filtro: this.filter });
  }

  get(page) {
    this.spinner.show();
    var params = {
      NUM_ELEMENTOS: this.pageSize,
      NUM_PAGINA: page,
      FILTRO: this.FILTER,
      FAULT_STATUS_CODE: this.grupoVal.controls.FAULT_STATUS_CODE.value || null,
      FECHAINI: this.grupoVal.controls.FECHAINI.value || null,
      FECHAFIN: this.grupoVal.controls.FECHAFIN.value || null
    };

    this.gateway.get('getFallasPendientesPagineo', params).then((result: any) => {
      this.dataSource = result.rows || [];

      this.gateway.get('getFallasPendientesCount', params).then((countResult: any) => {
        this.resultsLength = countResult.total || 0;
        this.spinner.hide();
      });
    }).catch((e) => {
      this.spinner.hide();
    });
  }

  cambioElementos(event?: PageEvent) {
    this.actpage = event.pageIndex;
    this.get(event.pageIndex);
  }

  filtrarAgente(data) {
    this.FILTER = data;
    this.get(0);
  }

  limpiarFiltros() {
    this.filter = '';
    this.FILTER = '';
    this.grupoVal.reset({ BUSCAR: '', FAULT_STATUS_CODE: '', FECHAINI: '', FECHAFIN: '' });
    if (this.paginatortable) {
      this.paginatortable.firstPage();
    }
    this.get(0);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.subscription) this.subscription.unsubscribe();
    if (this.subscriptionpais) this.subscriptionpais.unsubscribe();
  }
}
